import {
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import L from "leaflet";
import Carousel from "react-material-ui-carousel";
import Box from "@mui/material/Box";

const style = (feature) => {
  let type = feature.properties.agency;
  const defaultStyle = {
    dashArray: "10, 10",
    weight: 8,
    opacity: 0.5,
    stroke: "#008000",
    strokeWidth: "2px",
  };
  if (type === "CTA") {
    return { ...defaultStyle, color: "#c78787" };
  }
  if (type === "METRA") {
    return { ...defaultStyle, color: "#c78787" };
  }
  if (type === "STL") {
    return { ...defaultStyle, color: "#c78787" };
  }
  return defaultStyle;
};

const PopupTemplate = (props) => {
  const feature = props.feature;
  var agency = "";
  if (feature.properties.agency === "STL") agency = "St. Louis Metro";
  else agency = feature.properties.agency;
  return (
    <Card sx={{ borderRadius: 3, overflow: "auto", minWidth: 200 }}>
      <CardHeader className="styledtablerow" />
      <Carousel
        sx={{ minHeight: 100, marginTop: -2 }}
        navButtonsProps={{
          size: "small",
          style: {
            borderRadius: 10,
            marginLeft: -10,
            marginRight: -10,
            marginTop: 0,
            marginBottom: -2,
            opacity: 0.5,
            color: " #00549f",
          },
        }}
        navButtonsAlwaysVisible={
          Object.keys(feature.properties.descriptionList).length > 1
        }
        indicators={false}
      >
        {Object.keys(feature.properties.descriptionList).map((elementId) => {
          return (
            <Card sx={{ borderRadius: 3 }} key={elementId}>
              <CardHeader
                title={<font className="layer-title"> {agency}</font>}
                className="styledtablerow"
                sx={{ pb: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 1 }}
              />

              <CardContent
                size="small"
                sx={{
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: 3,
                  paddingRight: 3,
                  "&:last-child": { paddingBottom: 0 },
                }}
              >
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell className={"layertablecellLeft"}>
                        {feature.properties.headerList[elementId]}
                      </TableCell>
                    </TableRow>
                    <TableRow className="styledtablerow">
                      <TableCell className={"layertablecellLeft"}>
                        {feature.properties.descriptionList[elementId]}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell className={"layertablecellLeft"}>
                        More details
                      </TableCell>
                      <TableCell className={"reportCell layertablecellRight"}>
                        <a
                          href={feature.properties.eventUrlList[elementId]}
                          target="_blank"
                          rel="noreferrer"
                          style={{ textDecoration: "none", overflow: "auto" }}
                          className="hyper-links"
                        >
                          {" "}
                          Click here{" "}
                        </a>
                      </TableCell>
                    </TableRow>
                    {feature.properties.timePeriodsList[elementId] !== null &&
                      feature.properties.timePeriodsList[elementId] !== "" &&
                      feature.properties.timePeriodsList[elementId].length >
                        0 && (
                        <TableRow className="styledtablerow">
                          <TableCell className={"layertablecellLeft"}>
                            Time period
                          </TableCell>
                          <TableCell className={"layertablecellRight"}>
                            {feature.properties.timePeriodsList[elementId]}
                          </TableCell>
                        </TableRow>
                      )}

                    {feature.properties.effectList[elementId] !==
                      "Unknown Effect" &&
                      feature.properties.effectList[elementId] !== "" && (
                        <TableRow>
                          <TableCell className={"layertablecellLeft"}>
                            Effect
                          </TableCell>
                          <TableCell className={"layertablecellRight"}>
                            {feature.properties.effectList[elementId]}
                          </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          );
        })}
      </Carousel>
    </Card>
  );
};

var icon = L.icon({
  iconUrl:
    process.env.PUBLIC_URL +
    "/mapicons/Transit_Incident/Transit_Incident_A.png",
  iconSize: [21, 21], // size of the icon
  popupAnchor: [0, 0], // point from which the popup should open relative to the iconAnchor
});

const getLeafletIcon = (feature, latlng) => {
  var title = "Transit ALert";
  return L.marker(latlng, { icon: icon, title: title, alt: title });
};

const LegendTemplate = (props) => {
  const url =
    process.env.PUBLIC_URL + "/mapicons/Transit_Incident/Transit_Alert_v27.png";
  return (
    <Box sx={{ display: "flex", height: "20px" }}>
      <Box sx={{ ml: 8, display: "flex" }}>
        <Box
          sx={{
            backgroundImage: `url(${url})`,
            backgroundSize: "contain",
            width: "100px",
            backgroundRepeat: "no-repeat",
          }}
        ></Box>
      </Box>
    </Box>
  );
};

const module = {
  name: "Transit Alerts",
  endpoint: "/transitEventMap.json?agency=ALL&noBus=true&noTrivial=true",
  showOnMap: true,
  polygonLayer: true,
  PopupTemplate: PopupTemplate,
  updateDelay: 180,
  mapLayerIcon:
    process.env.PUBLIC_URL +
    "/mapicons/Transit_Incident/Transit_Incident_A.png",
  LegendTemplate: LegendTemplate,
  style: style,
  maxZoom: 9,
  getLeafletIcon: getLeafletIcon,
  defaultOn: false,
  zIndex: 639,
};

export default module;
